import axios from "axios";
import config from "src/config";

const URLLOGS = config.url.URLLOGS;

export const LogsAPI = {
  async save(contextData, logsData) {
    try {
      const headers = {
            'Content-Type': 'application/json',
            'customer': contextData.clientId,
            'session-id': contextData.sessionId,
            'sso': contextData.cookie
          }
      const response = await axios.post(URLLOGS, logsData, { headers });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  }
};
